<!-- Bottom Bar: visible only on mobile -->
<nav *ngIf="isMobile()" class="fixed bottom-0 left-0 right-0 z-50 bottom-bar-container">
    <div
        class="grid grid-cols-5 items-center pb-2 pt-2 bg-dark-secondary rounded-t-3xl shadow-[0_-8px_20px_rgba(0,0,0,0.15)] safe-area-bottom relative">
        <!-- Inicio -->
        <a [routerLink]="primaryItems[0].route" routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: true}"
            class="flex flex-col items-center justify-center py-1.5 nav-tab transition-colors"
            (click)="closeMenu()">
            <span class="material-symbols-rounded text-[24px] mb-0.5">{{ primaryItems[0].icon }}</span>
            <span class="text-[11px] font-medium">{{ primaryItems[0].title }}</span>
        </a>

        <!-- Transacciones -->
        <a id="bottom-nav-transactions" [routerLink]="primaryItems[1].route" routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}"
            class="flex flex-col items-center justify-center py-1.5 nav-tab transition-colors"
            (click)="closeMenu()">
            <span class="material-symbols-rounded text-[24px] mb-0.5">{{ primaryItems[1].icon }}</span>
            <span class="text-[11px] font-medium">{{ primaryItems[1].title }}</span>
        </a>

        <!-- Spacer for FAB -->
        <div></div>

        <!-- Actual FAB Button -->
        <div class="absolute left-1/2 -top-3 -translate-x-1/2">
            <button id="bottom-nav-fab" (click)="onFabTap()"
                class="w-[60px] h-[60px] bg-brand-primary text-gray-900 rounded-full flex items-center justify-center transition-transform active:scale-95 shadow-xl ring-4 ring-dark-secondary">
                <span class="material-symbols-rounded text-[28px] font-bold">add</span>
            </button>
        </div>

        <!-- Tarjetas -->
        <a id="bottom-nav-cards" [routerLink]="primaryItems[2].route" routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}"
            class="flex flex-col items-center justify-center py-1.5 nav-tab transition-colors"
            (click)="closeMenu()">
            <span class="material-symbols-rounded text-[24px] mb-0.5">{{ primaryItems[2].icon }}</span>
            <span class="text-[11px] font-medium">{{ primaryItems[2].title }}</span>
        </a>

        <!-- Menú -->
        <button id="bottom-nav-menu" class="flex flex-col items-center justify-center py-1.5 nav-tab transition-colors"
            [class.active-tab]="isMenuOpen" (click)="onNavItemClick(primaryItems[3])">
            <span class="material-symbols-rounded text-[24px] mb-0.5">{{ isMenuOpen ? 'close' : primaryItems[3].icon
                }}</span>
            <span class="text-[11px] font-medium">{{ primaryItems[3].title }}</span>
        </button>
    </div>
</nav>

<!-- Fullscreen Menu Overlay -->
<div *ngIf="isMenuOpen && isMobile()" class="fixed inset-0 z-40 glass-menu flex flex-col animate-fadeIn pb-20"
    (click)="closeMenu()">

    <!-- Close button -->
    <div class="flex justify-end p-6 safe-area-top">
        <button (click)="closeMenu()" class="text-white/80 hover:text-white transition-colors">
            <span class="material-symbols-rounded text-3xl">close</span>
        </button>
    </div>

    <!-- Menu title -->
    <div class="px-8 mb-6">
        <h2 class="text-2xl font-bold text-white font-sans">{{ TEXT.SIDEBAR.MENU_TITLE }}</h2>
    </div>

    <!-- Menu items -->
    <nav class="flex-1 px-8 space-y-1" (click)="$event.stopPropagation()">
        <a *ngFor="let item of (menuItems$ | async)" [routerLink]="item.route" routerLinkActive="menu-item-active"
            class="flex items-center gap-4 px-4 py-4 text-neutral-border hover:text-white hover:bg-white/10 rounded-2xl transition-all duration-200"
            (click)="closeMenu()">
            <span class="material-symbols-rounded text-[24px]">{{ item.icon }}</span>
            <span class="text-lg font-medium">{{ item.title }}</span>
        </a>
    </nav>
</div>